import { PartyCaseDto } from '@g2-shared/api-client/generated/onboarding-app';
import { getServerErrorMessage } from '@g2-shared/common';
import { useQuery } from 'react-query';
import { usePartyQuestionnaireFilledApiDefaultConfig } from '../../../questionnaireFilled/config';
import { FIND_PARTY_CASE_BY_SERVICE_CODE_FOR_USER } from '../../config';
import { DIContext } from '../../context';

interface useFindPartyCaseByServiceCodeForUserInterface {
  partyCase?: PartyCaseDto;
  isLoading: boolean;
  errorMessage: string;
  refetch: () => void;
}

export const useFindPartyCaseByServiceCodeForUser = (
  serviceCode: string,
  hideError?: boolean
): useFindPartyCaseByServiceCodeForUserInterface => {
  const config = usePartyQuestionnaireFilledApiDefaultConfig(
    'useFindPartyCaseByServiceCodeForUser'
  );
  const { OnboardingApiClient } = DIContext;

  const { data, isLoading, error, refetch } = useQuery(
    [FIND_PARTY_CASE_BY_SERVICE_CODE_FOR_USER, serviceCode],
    async () => {
      const response = await OnboardingApiClient.getPartyCaseByServiceCodeForApplicationAndUser({
        serviceCode,
      });
      return response.data.result;
    },
    {
      ...config,
      onError: hideError ? undefined : config.onError,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5000,
    }
  );

  return {
    partyCase: data,
    isLoading,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
    refetch,
  };
};
